import { useQuery } from "react-query";

import httpClient from "utils/http-client";
// import { API_FORGOT_PASSWORD_CONFIRM } from "consts";
import { API_RESET_PASSWORD } from "consts";

// TODO: temporarily using reset password API to get email for forgot password confirm
export default function useEmailForForgotPasswordConfirm(token, ...config) {
  return useQuery(
    ["emailForForgotPasswordConfirm", token],
    () => httpClient.get(API_RESET_PASSWORD.replace(":token", token)),
    // () => httpClient.get(`${API_RESET_PASSWORD}/${token}`),
    ...config
  );
}
